import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core-services/auth.service';
import { environment } from '@environments/environment';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  // LOCAL: bypass do guard — remover quando for para produção
  if ((environment as any).local) return true;

  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredPermissions: string[] = route.data?.['permissions'] ?? [];

  return authService.getPermissions().pipe(
    take(1),
    map(perms => {
      if (!authService.isAuthenticated()) {
        router.navigate(['/auth/login'])
        return false;
      }

      if (requiredPermissions.length === 0) return true;

      const hasPermission = requiredPermissions.some(p => perms?.includes(p));

      if (!hasPermission) {
        router.navigate(['/auth/no-permission']);
        return false;
      }

      return true;
    })
  );
};
